import axios from '../axios';
import { checkResponse, checkResponseErr, getProjectId } from '../utils';
import { apiV1 } from '../utils/constant';

/**
 * @function getStandardTree
 * @desc 获取指标列表
 * @param {Number} projectId 项目id
 * @returns {Object} 返回指标列表信息
 */
function getStandardTree() {
  return axios.get(`${apiV1}/projects/${getProjectId()}/standard?status=fasle`).then(checkResponse);
}

/**
 * @function getAllStandardTree
 * @desc 获取树数据 - 指标接口方法
 * @param {Number} projectId 项目id
 * @returns {Object} nodes 返回树节点信息
 * @returns {Number} nodes.parentId 父节点
 * @returns {String} nodes.label 节点名称
 * @returns {Number} nodes.value 节点id
 * @returns {Number} nodes.level 层级
 * @returns {Boolean} nodes.leaf 当前是否是叶子节点
 */
function getAllStandardTree() {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/standard`)
    .then(checkResponse)
    .catch(checkResponseErr);
}

/**
 * @function getStandardsListData
 * @desc 获取指标列表树
 * @param {Number} projectId 项目id
 * @returns {Object} 返回指标列表信息
 */
function getStandardsListData() {
  return axios.get(`${apiV1}/projects/${getProjectId()}/standard?as=tree`).then(checkResponse);
}

/**
 * @function setUpStandard
 * @desc 指标启用、禁用
 * @param {Number} projectId 项目id
 * @returns
 */
function setUpStandard(id, status) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/standard/nodes_status?node_id=${id}&status=${status}`)
    .then(checkResponse);
}
/**
 * @function newStandards
 * @desc 新建指标列表
 * @param {Number} projectId 项目id
 * @param {Array} nodes 指标名称数组
 * @param {Number} parent_id 父级id
 * @returns {Object} 返回指标列表信息
 */
function newStandards(data) {
  return axios
    .post(`${apiV1}/projects/${getProjectId()}/standard/nodes_batch`, data)
    .then(checkResponse);
}
/**
 * @function editStandards
 * @desc 编辑指标列表
 * @param {Number} projectId 项目id
 * @param {String} title 指标名称
 * @returns {Object} 返回指标列表信息
 */
function editStandards(id, data) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/standard/nodes?node_id=${id}`, {
      data,
    })
    .then(checkResponse);
}

/**
 * @function delStandards
 * @desc 删除指标列表
 * @param {Number} projectId 项目id
 * @param {Number} node_id 指标id
 * @returns {Object} 返回指标列表信息
 */
function delStandards(id) {
  return axios
    .delete(`${apiV1}/projects/${getProjectId()}/standard/nodes?node_id=${id}`)
    .then(checkResponse);
}

/**
 * @function getSampleStandard
 * @desc 指标示例树
 * @returns {Object}
 */
function getSampleStandard() {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/standard/sample`)
    .then(checkResponse)
    .then((res) => {
      return res.data;
    });
}

/**
 * @function useStandardsArea
 * @desc 使用指标示例
 * @returns {Object}
 */
function useStandardsArea() {
  return axios
    .put(`/api/v1/projects/${getProjectId()}/use_sample`, {
      utype: 'standards',
    })
    .then(checkResponse);
}

/**
 * @function addTextNodesStandard
 * @desc 批量添加指标
 * @param {Object} data 指标树
 * @returns {Object}
 */
function addTextNodesStandard(data) {
  return axios
    .post(`/api/v1/projects/${getProjectId()}/standard/text_nodes`, data)
    .then(checkResponse);
}
/**
 * @function delStandardBatch
 * @desc 批量删除指标
 * @returns {Object}
 */
function delStandardBatch(params) {
  return axios
    .delete(`${apiV1}/projects/${getProjectId()}/standard/nodes_batch`, { params })
    .then(checkResponse);
}
/**
 * @function orderArea
 * @desc 指标排序
 * @returns {Object}
 */
function orderStandard(data) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/standard/order_nodes`, data)
    .then(checkResponse);
}
/**
 * @function setUpStandard
 * @desc 指标普通、特殊
 * @param {Number} projectId 项目id
 * @returns
 */
function setSpecialStandard(id, status) {
  return axios
    .put(
      `${apiV1}/projects/${getProjectId()}/standard/update_special_status?node_id=${id}&status=${status}`,
    )
    .then(checkResponse);
}
export {
  useStandardsArea,
  getStandardTree,
  getAllStandardTree,
  getStandardsListData,
  getSampleStandard,
  setUpStandard,
  newStandards,
  editStandards,
  delStandards,
  addTextNodesStandard,
  delStandardBatch,
  orderStandard,
  setSpecialStandard,
};
